<!--货场列表-->
<template>
  <el-button-group>
    <el-button v-if="this.$fun.isQx(this.qx, 'yard:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'yard:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'yard:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'yard:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
  </el-button-group>
  <div class="fun">
    <div class="search-div">
      <el-select v-model="searchYardGrade" filterable clearable placeholder="请选择货场等级" class="width">
        <el-option
          v-for="item in yardGradeData" :key="item.value" :label="item.key" :value="item.value">
        </el-option>
      </el-select>
      <el-input placeholder="请输入关键字" prefix-icon="el-icon-search" v-model="searchKey" clearable class="width"></el-input>
      <el-button type="primary" icon="search" @click="getData">查询</el-button>
    </div>
    <STC colName="yardColumn" :colList="colList" />
  </div>
  <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border
      :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange"
      header-row-class-name="header-row" header-cell-class-name="header-cell">
    <el-table-column type="selection" width="40"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '货场名称')" prop="name" label="货场名称" show-overflow-tooltip>
      <template #default="scope">
        {{scope.row.name}}
      </template>
    </el-table-column>
     <el-table-column v-if="this.$fun.isExist(checkColList, '审核')" label="审核" width="100">
      <template #default="scope">
        <span v-if="scope.row.isAudit" >已核核</span>
        <span v-else>未审核</span>
      </template>
    </el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '货场等级')" prop="yardGradeName" label="货场等级" width="100"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '货场地址')" prop="address" label="货场地址" show-overflow-tooltip></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '联系人')" prop="linkman" label="联系人" width="100"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '联系人电话')" prop="phone" label="联系人电话" width="120"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '登录名')" prop="loginname" label="登录名" width="120"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '排序')" prop="queue" label="排序" width="60">
      <template #default="scope">
        <el-icon class="icon-cursor" @click="queueInfo(scope.row.id, false)"><SortDown /></el-icon>
        <el-icon class="icon-cursor" :title=scope.row.queue @click="queueInfo(scope.row.id, true)"><SortUp /></el-icon>
      </template>
    </el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '状态')" label="状态" width="60">
      <template #default="scope">
        <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
        <el-icon v-else class="close" title="禁用"><Close /></el-icon>
      </template>
    </el-table-column>
    <!-- <el-table-column v-if="this.$fun.isExist(checkColList, '录入人')" prop="inputter" label="录入人" width="100"></el-table-column> -->
    <el-table-column v-if="this.$fun.isExist(checkColList, '录入时间')" prop="upTime" label="录入时间" sortable width="150">
      <template #default="scope">
        <el-tooltip effect="dark"
          :disabled="scope.row.editTime === null"
          :content=scope.row.editTime placement="top">
          <span>{{scope.row.upTime}}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="100">
      <template #default="scope">
        <el-link v-if="this.$fun.isQx(this.qx, 'yard:edit')" type="primary" :underline="false" @click="editInfo(scope.row.id)">修改</el-link>
        &nbsp;&nbsp;
        <el-link v-if="this.$fun.isQx(this.qx, 'yard:audit')" type="primary" :underline="false" @click="auditInfo(scope.row)">审核</el-link>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
   :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
   :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
  </el-pagination>
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm" append-to-body="true" width="60%">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden" class="none"></el-input>
      <el-form-item label="货场名称" prop="name">
        <el-input v-model="form.name" maxlength="100" class="width5"></el-input>
      </el-form-item>
      <el-form-item label="货场等级" prop="yardGrade">
        <el-select v-model="form.yardGrade" filterable clearable placeholder="请选择货场等级">
          <el-option
            v-for="item in yardGradeData" :key="item.value" :label="item.key" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="货场地址" prop="address">
        <el-input v-model="form.address" maxlength="100" class="width5"></el-input>
      </el-form-item>
      <el-form-item label="货场简介" prop="intro" class="clear">
        <el-input v-model="form.intro" type="textarea" rows=5 maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="linkman" class="flaot-left">
          <el-input v-model="form.linkman" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="phone">
          <el-input v-model="form.phone" maxlength="11" @change="phoneInputChange" class="width"></el-input>
      </el-form-item>
      <el-form-item label="登录名" prop="loginname" class="flaot-left">
          <el-input v-model="form.loginname" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="loginpwd">
        <el-input v-model="form.loginpwd" show-password class="width"></el-input>
        <el-tooltip effect="customized">
          <template #content>添加时密码为空表示默认密码是:123456；<br />修改时密码为空表示不改原密码。</template>
          <el-icon :size="16"><InfoFilled /></el-icon>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="备注" prop="remark" class="clear">
        <el-input v-model="form.remark" type="textarea" rows=5 maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="排序(降序)">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 货场审核对话框 -->
  <el-dialog title="货场审核" v-model="dialogAuditVisible" :close-on-click-modal="false" :before-close="closeAuditForm">
    <div class="center">货场注册后默认是未审核的，在此确认审核及指定货场等级。</div>
    <div style="margin-top: 20px">
      <el-form :model="form1" label-width="130px">
        <el-input v-model="form1.id" type="hidden" class="none"></el-input>
        <el-form-item label="货场审核">
          <el-switch v-model="form1.isAudit" active-text="已审" inactive-text="未审"></el-switch>
        </el-form-item>
        <el-form-item label="货场等级">
        <el-select v-model="form1.yardGrade" filterable clearable placeholder="请选择货场等级">
          <el-option
            v-for="item in yardGradeData" :key="item.value" :label="item.key" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeAuditForm">关 闭</el-button>
        <el-button type="primary" @click="saveAudit">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
// 选择显示的表列
import STC from '@/components/SelectTableColumn'
export default {
  name: 'yard',
  components: {
    STC
  },
  data () {
    return {
      qx: '',
      colList: ['货场名称', '审核', '货场等级', '货场地址', '联系人', '联系人电话', '登录名', '审核', '排序', '状态', '录入时间'],
      checkColList: [],
      tableLoading: false,
      currentPage: 1,
      pagesize: 15,
      tableTotal: 0,
      tableData: [],
      selectionIds: '',
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        name: '',
        yardGrade: '',
        linkman: '',
        phone: '',
        loginname: '',
        loginpwd: '',
        address: '',
        intro: '',
        remark: '',
        queue: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入货场名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        yardGrade: [
          { required: true, message: '请选择货场等级', trigger: 'blur' }
        ],
        linkman: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          {
            // pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
            // message: '请输入正确的手机号码或者座机号'
            pattern: /^(1[3458]\d{9})$/,
            message: '请输入正确的手机号码'
          }
          // { type: 'number', message: '电话必须为数字值' }
          // { min: 2, max: 50, message: '长度在 8 到 50 个字符', trigger: 'blur' }
        ],
        loginname: [
          { required: true, message: '请输入登录名', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        loginpwd: [
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      },
      // 是否可点击
      disabled: false,
      searchKey: '',
      searchDate: '',
      searchYardGrade: '',
      yardGradeData: [],
      defaultTime: ([
        new Date(2000, 1, 1, 0, 0, 0),
        new Date(2000, 2, 1, 23, 59, 59)
      ]),
      dialogAuditVisible: false,
      form1: {
        id: '',
        isAudit: false,
        yardGrade: ''
      }
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    // const ui = this.$api.ui
    // if (ui == null) {
    //   this.$router.push({ path: '/login' })
    // }
    this.getTableHeight()
    // this.$route.params.sid this.$route.query.sid
    this.getData()
    this.getYardGradeData()
  },
  methods: {
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectionIds = ''
      for (var i = 0; i < val.length; i++) {
        if (this.selectionIds === '') {
          this.selectionIds = val[i].id
        } else {
          this.selectionIds += ',' + val[i].id
        }
      }
    },
    async getData () {
      this.tableLoading = true
      const params = '?type=' + this.searchYardGrade + '&key=' + this.searchKey + '&date=' + this.searchDate + '&pagesize=' + this.pagesize + '&pageindex=' + this.currentPage
      const { data: ret } = await this.$http.get(this.$api.yardlist + params)
      if (ret.status === 0) {
        this.tableData = ret.data.rows
        this.tableTotal = ret.data.total
        console.log('tableData=', this.tableData)
      }
      this.tableLoading = false
    },
    async getYardGradeData () {
      const { data: ret } = await this.$http.get(this.$api.dictItemListByCode + '?code=yard-grade')
      // console.log('typeret=', ret)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.yardGradeData = ret.data
      }
    },
    addInfo () {
      this.dialogTitle = '添加货场信息'
      this.dialogFormVisible = true
      this.form.id = ''
    },
    async editInfo (id) {
      this.dialogFormVisible = true
      const { data: ret } = await this.$http.get1(this.$api.yardid + '/' + id)
      if (ret.status === 0 && ret.data !== null) {
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.dialogTitle = '修改货场信息'
      } else {
        this.$message.error(ret.message)
      }
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // console.log('this.form=', this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.yardsave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.yarddel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.yardenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    async queueInfo (id, bo) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?id=' + id + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.yardqueue + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    // 审核
    auditInfo (row) {
      this.form1.id = row.id
      this.form1.isAudit = row.isAudit
      this.form1.yardGrade = row.yardGrade
      this.dialogAuditVisible = true
    },
    async saveAudit () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?id=' + this.form1.id + '&bo=' + this.form1.isAudit + '&grade=' + this.form1.yardGrade
      const { data: ret } = await this.$http.post(this.$api.yardaudit + params)
      if (ret.status === 0) {
        this.$message.success(ret.message)
        this.getData()
        this.closeAuditForm()
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    // 联系电话输入
    phoneInputChange (e) {
      // 添加时与登录名同步
      if (this.form.id === '') {
        this.form.loginname = e
      }
    },
    resetForm () {
      this.$refs.formRef.resetFields()
      this.form.content = ''
      this.form.queue = 0
      this.htmlContent = ''
    },
    closeForm () {
      this.resetForm()
      this.dialogFormVisible = false
    },
    closeAuditForm () {
      this.dialogAuditVisible = false
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 88 - 42 - 35
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.center {
  text-align: center;
}
</style>
